var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, GridCol, GridRow, StateConfigContext, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { useContext, useEffect, useRef, useState } from 'react';
import { CalloutWidget } from '../callout-widget';
import { RadioGroupWidget } from '../radio-group-widget';
import { FormTypes } from './ContactDetailFormWidgetPropTypes';
import { getContactDetailFormWidgetStyles } from './ContactDetailFormWidgetStyles';
import { InputFormField } from './components/input-form-field';
export var ContactDetailFormWidgetComponent = props => {
  var _a;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var id = props.id,
    _props$formVariant = props.formVariant,
    formVariant = _props$formVariant === void 0 ? FormTypes.WITH_NAME_AND_NUMBER : _props$formVariant,
    calloutIconName = props.calloutIconName,
    calloutTitle = props.calloutTitle,
    calloutDescription = props.calloutDescription,
    _props$calloutType = props.calloutType,
    calloutType = _props$calloutType === void 0 ? 'lilac' : _props$calloutType,
    _props$calloutPositio = props.calloutPosition,
    calloutPosition = _props$calloutPositio === void 0 ? 'top' : _props$calloutPositio,
    buttonText = props.buttonText,
    _props$isButtonDisabl = props.isButtonDisabled,
    isButtonDisabled = _props$isButtonDisabl === void 0 ? false : _props$isButtonDisabl,
    buttonOnPressMetaData = props.buttonOnPressMetaData,
    _props$showSubmitButt = props.showSubmitButton,
    showSubmitButton = _props$showSubmitButt === void 0 ? true : _props$showSubmitButt,
    _props$showSecondaryB = props.showSecondaryButton,
    showSecondaryButton = _props$showSecondaryB === void 0 ? false : _props$showSecondaryB,
    shouldShowButtonLoader = props.shouldShowButtonLoader,
    onValidFormMetaData = props.onValidFormMetaData,
    _props$isValidFormCal = props.isValidFormCallWithDebounce,
    isValidFormCallWithDebounce = _props$isValidFormCal === void 0 ? false : _props$isValidFormCal,
    _props$debounceDelay = props.debounceDelay,
    debounceDelay = _props$debounceDelay === void 0 ? 800 : _props$debounceDelay,
    onSubmit = props.onSubmit,
    onUserAction = props.onUserAction,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ContactDetailFormWidget' : _props$testID,
    buttonAccessibilityProps = props.buttonAccessibilityProps,
    buttonContainerStyle = props.buttonContainerStyle,
    seconadryButtonAccessibilityProps = props.seconadryButtonAccessibilityProps,
    buttonWidgetProps = props.buttonWidgetProps,
    secondaryButtonWidgetProps = props.secondaryButtonWidgetProps,
    secondaryButtonOnPressMetaData = props.secondaryButtonOnPressMetaData,
    radioGroupProps = props.radioGroupProps,
    secondaryButtonContainerStyle = props.secondaryButtonContainerStyle,
    gridColProps = props.gridColProps,
    gridRowProps = props.gridRowProps,
    restProps = __rest(props, ["id", "formVariant", "calloutIconName", "calloutTitle", "calloutDescription", "calloutType", "calloutPosition", "buttonText", "isButtonDisabled", "buttonOnPressMetaData", "showSubmitButton", "showSecondaryButton", "shouldShowButtonLoader", "onValidFormMetaData", "isValidFormCallWithDebounce", "debounceDelay", "onSubmit", "onUserAction", "testID", "buttonAccessibilityProps", "buttonContainerStyle", "seconadryButtonAccessibilityProps", "buttonWidgetProps", "secondaryButtonWidgetProps", "secondaryButtonOnPressMetaData", "radioGroupProps", "secondaryButtonContainerStyle", "gridColProps", "gridRowProps"]);
  var _useState = useState({}),
    formData = _useState[0],
    setFormData = _useState[1];
  var _useState2 = useState(isButtonDisabled),
    isButtonEnabled = _useState2[0],
    setIsButtonEnabled = _useState2[1];
  var _useState3 = useState(radioGroupProps === null || radioGroupProps === void 0 ? void 0 : radioGroupProps.checkedRadioId),
    checkedRadioId = _useState3[0],
    setCheckedRadioId = _useState3[1];
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    breakpoint = _useBreakpoint.breakpoint,
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var contactDetailFormWidgetStyles = getContactDetailFormWidgetStyles(breakpoint, isLargeScreen);
  var fieldValidity = useRef({
    number: formVariant === FormTypes.PERSONAL_DETAILS ? null : false,
    name: formVariant === FormTypes.ONLY_NUMBER || formVariant === FormTypes.PERSONAL_DETAILS ? null : false,
    altNumber: formVariant === FormTypes.WITH_EMAIL_AND_ALT_NUMBER || formVariant === FormTypes.PERSONAL_DETAILS ? false : null,
    email: formVariant === FormTypes.WITH_EMAIL_AND_ALT_NUMBER || formVariant === FormTypes.PERSONAL_DETAILS ? false : null,
    language: [FormTypes.WITH_NUMBER_AND_LANGUAGE, FormTypes.WITH_NUMBER_NAME_AND_LANGUAGE, FormTypes.ONLY_LANGUAGE].includes(formVariant) ? false : null,
    pincode: formVariant === FormTypes.PERSONAL_DETAILS ? false : null
  });
  var validCallbackTimer = useRef();
  var formDataRef = useRef({});
  useEffect(() => {
    formDataRef.current = formData;
  }, [JSON.stringify(formData)]);
  var onFieldValidityChangeCallback = (fieldId, isValid) => {
    fieldValidity.current = Object.assign(Object.assign({}, fieldValidity.current), {
      [fieldId]: isValid
    });
    setCTAEnabled();
  };
  var setCTAEnabled = () => {
    var isValid = isButtonEnabled;
    for (var key in fieldValidity.current) {
      var _key = key;
      if (fieldValidity.current[_key] != null && !fieldValidity.current[_key]) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    setIsButtonEnabled(isValid);
    if (validCallbackTimer.current) clearTimeout(validCallbackTimer.current);
    if (isValidObject(onValidFormMetaData) && isValid) {
      if (isValidFormCallWithDebounce) {
        validCallbackTimer.current = setTimeout(() => {
          validCallbackTimer.current = null;
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formDataRef.current);
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onValidFormMetaData), Object.assign({
            props
          }, formDataRef.current));
        }, debounceDelay);
      } else {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formDataRef.current);
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onValidFormMetaData), Object.assign({
          props
        }, formDataRef.current));
      }
    }
  };
  var setFormFieldData = (fieldId, value) => {
    setFormData(oldFormData => Object.assign(Object.assign({}, oldFormData), {
      [fieldId]: value
    }));
  };
  var getSingleFieldProps = fieldId => {
    var pascalCaseFieldId = fieldId.charAt(0).toUpperCase() + fieldId.slice(1);
    var data = Object.assign({}, restProps);
    return Object.assign(Object.assign({
      fieldId: fieldId,
      label: data === null || data === void 0 ? void 0 : data[fieldId + "Label"],
      value: data === null || data === void 0 ? void 0 : data[fieldId + "Value"],
      defaultValue: data === null || data === void 0 ? void 0 : data[fieldId + "DefaultValue"],
      inputRegex: data === null || data === void 0 ? void 0 : data[fieldId + "InputRegex"],
      validationRegex: data === null || data === void 0 ? void 0 : data[fieldId + "ValidationRegex"],
      invalidMsgForValidationRegex: data === null || data === void 0 ? void 0 : data[fieldId + "InvalidMsgForValidationRegex"],
      isDisabled: data === null || data === void 0 ? void 0 : data["is" + pascalCaseFieldId + "Disabled"],
      state: data === null || data === void 0 ? void 0 : data[fieldId + "State"],
      hintText: data === null || data === void 0 ? void 0 : data[fieldId + "HintText"],
      showLoader: data === null || data === void 0 ? void 0 : data["shouldShow" + pascalCaseFieldId + "Loader"],
      showAppend: data === null || data === void 0 ? void 0 : data["shouldShow" + pascalCaseFieldId + "Append"],
      appendItems: data === null || data === void 0 ? void 0 : data[fieldId + "AppendItems"],
      readOnly: data === null || data === void 0 ? void 0 : data[fieldId + "ReadOnly"],
      showLabelIcon: data === null || data === void 0 ? void 0 : data["shouldShow" + pascalCaseFieldId + "LabelIcon"],
      showLabelTooltipOnMount: data === null || data === void 0 ? void 0 : data["shouldShow" + pascalCaseFieldId + "LabelTooltipOnMount"],
      labelTooltipProps: data === null || data === void 0 ? void 0 : data[fieldId + "LabelTooltipProps"],
      labelAccessibilityProps: data === null || data === void 0 ? void 0 : data[fieldId + "LabelAccessibilityProps"],
      isExternalValidityRequired: data === null || data === void 0 ? void 0 : data["is" + pascalCaseFieldId + "ExternalValidityRequired"],
      isExternalValid: data === null || data === void 0 ? void 0 : data["is" + pascalCaseFieldId + "Valid"],
      maxLength: data === null || data === void 0 ? void 0 : data[fieldId + "MaxLength"],
      keyboardType: data === null || data === void 0 ? void 0 : data[fieldId + "KeyboardType"],
      placeholder: data === null || data === void 0 ? void 0 : data[fieldId + "Placeholder"],
      onChangeTextMetaData: data === null || data === void 0 ? void 0 : data["on" + pascalCaseFieldId + "ChangeText"],
      onValidInputMetaData: data === null || data === void 0 ? void 0 : data["on" + pascalCaseFieldId + "ValidInput"],
      onInValidInputMetaData: data === null || data === void 0 ? void 0 : data["on" + pascalCaseFieldId + "InValidInput"],
      onPressInMetaData: data === null || data === void 0 ? void 0 : data["on" + pascalCaseFieldId + "PressIn"],
      onFieldValidityChangeHandler: onFieldValidityChangeCallback,
      setFormFieldDataHandler: setFormFieldData,
      onUserAction: onUserAction
    }, getTestId(testID, fieldId)), {
      accessibilityProps: data === null || data === void 0 ? void 0 : data[fieldId + "AccessibilityProps"],
      hintTextAccessibilityProps: data === null || data === void 0 ? void 0 : data[fieldId + "HintTextAccessibilityProps"]
    });
  };
  var showCallout = !!calloutTitle || !!calloutDescription;
  var showRadio = ((_a = radioGroupProps === null || radioGroupProps === void 0 ? void 0 : radioGroupProps.radioButtons) === null || _a === void 0 ? void 0 : _a.length) > 0;
  var onRadioSelectionHandler = data => {
    setCheckedRadioId(data === null || data === void 0 ? void 0 : data.id);
    (data === null || data === void 0 ? void 0 : data.onRadioPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, data === null || data === void 0 ? void 0 : data.onRadioPressMetaData)));
  };
  return _jsxs(GridRow, Object.assign({}, gridRowProps, {
    children: [showCallout && calloutPosition == 'top' && _jsx(GridCol, Object.assign({
      breakpoints: {
        xs: 12
      },
      style: contactDetailFormWidgetStyles.topPadding
    }, gridColProps, {
      children: _jsx(CalloutWidget, Object.assign({}, getTestId(testID, 'callout'), {
        title: calloutTitle,
        description: calloutDescription,
        iconName: calloutIconName,
        state: calloutType
      }))
    })), showRadio && _jsx(GridCol, Object.assign({
      breakpoints: {
        xs: 12
      }
    }, gridColProps, {
      children: _jsx(RadioGroupWidget, Object.assign({}, radioGroupProps, getTestId(testID, 'radio'), {
        checkedRadioId: checkedRadioId,
        onSelectionHandler: onRadioSelectionHandler,
        onUserAction: onUserAction
      }))
    })), formVariant == FormTypes.ONLY_LANGUAGE && _jsx(GridCol, Object.assign({
      noTopGutter: true
    }, gridColProps, {
      children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'onlyLanguage'), getSingleFieldProps('language'), {
        caretHidden: true,
        showAppend: true,
        readOnly: true,
        readOnlyOnPress: () => {
          var langProps = Object.assign({}, getSingleFieldProps('language'));
          langProps.onPressInMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id: langProps.fieldId
          }, langProps.onPressInMetaData)));
        },
        appendItems: {
          postfixIcon: {
            iconName: 'DownChevronIcon',
            iconColor: 'black'
          },
          isPressable: true
        }
      }))
    })), formVariant === FormTypes.WITH_ALT_NUMBER_AND_EMAIL && _jsxs(_Fragment, {
      children: [_jsx(GridCol, Object.assign({
        breakpoints: {
          xs: 12,
          lg: 6
        }
      }, gridColProps, {
        children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'altNumber'), getSingleFieldProps('altNumber')))
      })), _jsx(GridCol, Object.assign({
        breakpoints: {
          xs: 12,
          lg: 6
        }
      }, gridColProps, {
        children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'email'), getSingleFieldProps('email')))
      }))]
    }), formVariant === FormTypes.PERSONAL_DETAILS ? _jsxs(_Fragment, {
      children: [_jsx(GridCol, Object.assign({
        breakpoints: {
          xs: 12,
          lg: 6
        }
      }, gridColProps, {
        children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'altNumber'), getSingleFieldProps('altNumber'), {
          theme: theme
        }))
      })), _jsx(GridCol, Object.assign({
        breakpoints: {
          xs: 12,
          lg: 6
        }
      }, gridColProps, {
        children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'email'), getSingleFieldProps('email'), {
          theme: theme
        }))
      })), _jsx(GridCol, Object.assign({
        breakpoints: {
          xs: 12,
          lg: 6
        }
      }, gridColProps, {
        children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'pincode'), getSingleFieldProps('pincode'), {
          theme: theme
        }))
      }))]
    }) : _jsx(_Fragment, {
      children: formVariant == FormTypes.ONLY_NUMBER ? _jsx(GridCol, Object.assign({
        noTopGutter: true
      }, gridColProps, {
        children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'onlyNumber'), getSingleFieldProps('number')))
      })) : _jsxs(_Fragment, {
        children: [formVariant !== FormTypes.ONLY_LANGUAGE && formVariant !== FormTypes.WITH_ALT_NUMBER_AND_EMAIL && _jsx(GridCol, Object.assign({
          breakpoints: {
            xs: 12,
            lg: 6
          },
          style: !showCallout && contactDetailFormWidgetStyles.topPadding
        }, gridColProps, {
          children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'number'), getSingleFieldProps('number')))
        })), formVariant === FormTypes.WITH_NUMBER_AND_LANGUAGE ? _jsx(GridCol, Object.assign({
          breakpoints: {
            xs: 12,
            lg: 6
          }
        }, gridColProps, {
          children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'language'), getSingleFieldProps('language'), {
            caretHidden: true,
            showAppend: true,
            readOnly: true,
            readOnlyOnPress: () => {
              var langProps = Object.assign({}, getSingleFieldProps('language'));
              langProps.onPressInMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id: langProps.fieldId
              }, langProps.onPressInMetaData)));
            },
            appendItems: {
              postfixIcon: {
                iconName: 'DownChevronIcon',
                iconColor: 'black'
              },
              isPressable: true
            }
          }))
        })) : formVariant !== FormTypes.ONLY_LANGUAGE && formVariant !== FormTypes.WITH_ALT_NUMBER_AND_EMAIL && _jsx(GridCol, Object.assign({
          breakpoints: {
            xs: 12,
            lg: 6
          }
        }, gridColProps, {
          children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'name'), getSingleFieldProps('name')))
        }))]
      })
    }), formVariant == FormTypes.WITH_EMAIL_AND_ALT_NUMBER && _jsxs(_Fragment, {
      children: [_jsx(GridCol, Object.assign({
        breakpoints: {
          xs: 12,
          lg: 6
        }
      }, gridColProps, {
        children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'altNumber'), getSingleFieldProps('altNumber')))
      })), _jsx(GridCol, Object.assign({
        breakpoints: {
          xs: 12,
          lg: 6
        }
      }, gridColProps, {
        children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'email'), getSingleFieldProps('email')))
      }))]
    }), formVariant == FormTypes.WITH_NUMBER_NAME_AND_LANGUAGE && _jsx(GridCol, Object.assign({
      breakpoints: {
        xs: 12,
        lg: 6
      }
    }, gridColProps, {
      children: _jsx(InputFormField, Object.assign({}, getTestId(testID, 'language'), getSingleFieldProps('language'), {
        caretHidden: true,
        showAppend: true,
        readOnly: true,
        readOnlyOnPress: () => {
          var langProps = Object.assign({}, getSingleFieldProps('language'));
          langProps.onPressInMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id: langProps.fieldId
          }, langProps.onPressInMetaData)));
        },
        appendItems: {
          postfixIcon: {
            iconName: 'DownChevronIcon',
            iconColor: 'black'
          },
          isPressable: true
        }
      }))
    })), showCallout && calloutPosition == 'bottom' && _jsx(GridCol, Object.assign({
      breakpoints: {
        xs: 12
      },
      style: contactDetailFormWidgetStyles.topPadding
    }, gridColProps, {
      children: _jsx(CalloutWidget, Object.assign({}, getTestId(testID, 'callout'), {
        title: calloutTitle,
        description: calloutDescription,
        iconName: calloutIconName,
        state: calloutType
      }))
    })), showSubmitButton && _jsx(GridCol, Object.assign({
      breakpoints: {
        xs: 12,
        lg: 4
      }
    }, gridColProps, {
      style: [contactDetailFormWidgetStyles.buttonPadding, buttonContainerStyle]
    }, {
      children: _jsx(Button, Object.assign({}, buttonAccessibilityProps, buttonWidgetProps, getTestId(testID, 'button'), {
        version: "variable-width",
        disabled: !isButtonEnabled,
        title: buttonText,
        showLoader: shouldShowButtonLoader,
        onPress: () => {
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formDataRef.current);
          buttonOnPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, buttonOnPressMetaData), formDataRef === null || formDataRef === void 0 ? void 0 : formDataRef.current));
        }
      }))
    })), showSecondaryButton && _jsx(GridCol, Object.assign({
      breakpoints: {
        xs: 12,
        lg: 4
      }
    }, gridColProps, {
      style: [contactDetailFormWidgetStyles.buttonPadding, secondaryButtonContainerStyle]
    }, {
      children: _jsx(Button, Object.assign({}, seconadryButtonAccessibilityProps, secondaryButtonWidgetProps, getTestId(testID, 'button'), {
        onPress: () => {
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formDataRef.current);
          secondaryButtonOnPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, secondaryButtonOnPressMetaData), formDataRef.current));
        }
      }))
    }))]
  }));
};
ContactDetailFormWidgetComponent.genericRendererKey = 'AirContactDetailFormWidget';